let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cFtS7")).then(() => parcelRequire('jsBpx'));